import { render } from "./practiceHome.vue?vue&type=template&id=5209a0d6"
import script from "./practiceHome.vue?vue&type=script&lang=js"
export * from "./practiceHome.vue?vue&type=script&lang=js"

import "./practiceHome.vue?vue&type=style&index=0&id=5209a0d6&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__